export const CHARACTERISTIC_NAME = ['name', 'gender', 'status', 'species', 'location']
